/* ==========================================================================
   MICHELANGELO MUSIC - bundle price sync.  Added 2026-07-27.

   THE BUG
   Toggling the bundle swapped the variant but changed nothing on screen. The
   stock component does exactly one thing - set variantInput.value and flip
   data-selected - and never touches a price. So the sticky bar kept reading
   $24.99 / SAVE 28% while the form was armed to add the $29.99 bundle.

   THE CART WAS ALWAYS RIGHT. The sticky Add to cart button carries
   form="product-form-<section>", so it submits the same form the toggle
   mutates - the correct variant was always what got added. A display bug,
   not a billing one.

   SCOPE: THE STICKY BAR ONLY. This first shipped updating the main price
   block as well, and that was wrong. The headline price belongs to the
   PRODUCT - it is the Concrete Drum Kit's price, and it does not become a
   different number because a visitor ticked an upsell. Rewriting it made the
   page read as though the product itself had been repriced. Three elements
   each answer a different question and each should keep answering it:

     main price block   what this product costs      $24.99  (never changes)
     bundle card        what the bundle costs        $29.99 / $49.99
     sticky bar         what THIS BUTTON will add    follows the toggle

   Do not add the main price block back into PRICE_BLOCKS.

   APPROACH
   Prices are read out of the bundle card's own markup, which Liquid already
   rendered, so nothing is hard-coded and this stays correct when a price
   moves - it picked up the compare-at going 34.98 -> 49.99 with no edit, and
   recomputed the badge from SAVE 14% to SAVE 40% by itself. The block caches
   its original innerHTML and is restored verbatim on toggle-off, so this
   never rebuilds the theme's price markup, it only overwrites money text.

   Driven by a MutationObserver on data-selected rather than a second click
   handler on the toggle, so it cannot race the theme's own listener.

   Loaded globally from sections/header-group.json ("MM corrections
   stylesheet"). It exits immediately when there is no bundle selector, which
   is every page but two.
   ========================================================================== */

(function () {
  'use strict';

  /* The sticky bar and nothing else - see SCOPE above. */
  var PRICE_BLOCKS = '.sticky-atc__price .price';

  /* USD store, so a plain parse is safe. Strips the currency symbol and any
     thousands separator; treats a lone comma as the decimal mark so a future
     locale switch degrades to wrong-by-rounding rather than NaN. */
  function toNumber(text) {
    var s = String(text).replace(/[^0-9.,]/g, '');
    if (s.indexOf('.') < 0 && s.indexOf(',') > -1) s = s.replace(',', '.');
    s = s.replace(/,/g, '');
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function init(selector) {
    if (selector.dataset.mmPriceSync === 'true') return;
    selector.dataset.mmPriceSync = 'true';

    var realEl = selector.querySelector('.bundle-product-selector__price span');
    if (!realEl) return;
    var compareEl = selector.querySelector('.bundle-product-selector__price s');

    var realText = realEl.textContent.trim();
    var compareText = compareEl ? compareEl.textContent.trim() : '';

    var real = toNumber(realText);
    var compare = toNumber(compareText);
    var percent = (real !== null && compare !== null && compare > real)
      ? Math.round(((compare - real) / compare) * 100)
      : null;

    var cache = [];

    function apply(on) {
      var blocks = document.querySelectorAll(PRICE_BLOCKS);
      Array.prototype.forEach.call(blocks, function (block, i) {
        if (cache[i] === undefined) cache[i] = block.innerHTML;

        /* Restore first either way, so a re-apply never stacks on a block
           that is already swapped. */
        block.innerHTML = cache[i];
        if (!on) return;

        var set = function (sel, text) {
          if (!text) return;
          var el = block.querySelector(sel);
          if (el) el.textContent = text;
        };

        set('.price__regular .price-item--regular', realText);
        set('.price__sale .price-item--sale', realText);
        set('.price__compare-price s', compareText);
        if (percent !== null) set('.price__badge-sale .nowrap', 'SAVE ' + percent + '%');
      });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        apply(selector.dataset.selected === 'true');
      }).observe(selector, { attributes: true, attributeFilter: ['data-selected'] });
    } else {
      var toggle = selector.querySelector('.bundle-product-selector__toggle');
      if (toggle) {
        toggle.addEventListener('click', function () {
          setTimeout(function () { apply(selector.dataset.selected === 'true'); }, 0);
        });
      }
    }

    /* Shopify can restore a toggled state on a soft re-render, so read the
       current value rather than assuming off. */
    if (selector.dataset.selected === 'true') apply(true);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('bundle-product-selector').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
